//require('dotenv').config();

// ⚠️ DOIT RESTER LE PREMIER IMPORT. Ce module retire, à son évaluation, le
// paramètre anti-cache laissé dans l'URL par un rechargement de mise à jour.
// './router' appelle createWebHistory() à son propre import et mémorise
// window.location à cet instant : nettoyer après lui serait sans effet, le
// routeur rétablirait le paramètre au montage. Voir appVersionUrl.js.
import '@/service/appVersionUrl';

import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store/store';
//import { IonicVue, IonApp } from '@ionic/vue';
//import '@ionic/core/css/ionic.bundle.css';
import axios from 'axios';
import VueAxios from 'vue-axios';
import JwtService from "@/common/jwt.service";

import VueHtmlToPaper from 'vue-html-to-paper';

import './assets/app.css';
import './assets/charte.css';
import './registerServiceWorker'
/*import 'sweetalert2/dist/sweetalert2.min.css'  // 👈 le CSS ici*/
import Swal from 'sweetalert2'
import '@fortawesome/fontawesome-free/css/all.css';

import permissiondirective from '@/service/directives/permission';

window.Swal = Swal
const toastr = require('toastr');
window.toastr = toastr;
//********************************************************************************//

import { initDB,cleanAllExpiredData,forceDBVersionCheck,hardResetAll } from '@/service/indexedDBService';
   import {
        cleanExpiredOrders,
        _autoCleanCompleted,
        purgeTrash
    } from '@/service/orderQueueService';
   import { purgeComptabilisationVente } from '@/service/comptabilisationVenteService';
   import { demarrerSurveillance, VERSION_BUNDLE } from '@/service/appVersionService';
   import { afficherGateMiseAJour } from '@/service/appUpdateGate';
   import { installerRecuperationChunks } from '@/service/chunkLoadRecovery';
   import { demarrerSurveillanceReseau, verifierSessionAvecReprise, estErreurReseau } from '@/service/connexionReseau';

// Installé au plus tôt : une ChunkLoadError peut survenir dès le chargement
// d'une vue à la demande, donc avant même la fin du boot.
installerRecuperationChunks();

// Bandeau « hors connexion / connexion instable ». Installé tôt : il doit
// couvrir aussi les requêtes émises pendant le démarrage.
demarrerSurveillanceReseau();



//*******************************************************************//

axios.defaults.headers.common = {
    'X-Requested-With': 'XMLHttpRequest',
    'Accept':'application/json',
    'Content-Type':'application/json',
    'Access-Control-Allow-Origin': '*',
    'Access-Control-Allow-Methods': 'OPTIONS,GET,PUT,POST,DELETE',
    'Access-Control-Allow-Headers': 'Content-Type',

}
//axios.defaults.mode='no-cors';
axios.defaults.withCredentials = true;
axios.defaults.crossDomain = true;
axios.defaults.credentials = 'same-origin';

// Configurer l'intercepteur de réponse Axios
axios.interceptors.response.use(
    function (response) {

        // Vérifier si la variable statuts est définie
        if (response.data.statuts && response.data.statuts === 400) {
            // Déconnecter l'utilisateur
          console.log("Déconnexion de l'utilisateur en raison d'un statut 400");
                window.localStorage.clear();
                window.sessionStorage.clear();
                window.location.href = '/login';

                console.log("Déconnexion de l'utilisateur en raison d'un statut 400 2");

             

        }
        // Retourner la réponse si tout est OK
        //return response;
    },
    function () {
        // Gérer les erreurs de réponse

        //console.log("error",error)

       // return Promise.reject(error);
    }
);


toastr.options = {
    closeButton: true,
    debug: false,
    newestOnTop: false,
    progressBar: true,
    positionClass: "toast-top-center",
    preventDuplicates: false,
    onclick: null,
    showDuration: 500,
    hideDuration: 500,
    timeOut: 8000,
    extendedTimeOut: 5000,
    showEasing: "swing",
    hideEasing: "linear",
    showMethod: "fadeIn",
    hideMethod: "fadeOut",
};



const isset = (accessor) => {
    try {
        // Note we're seeing if the returned value of our function is not
        // undefined or null
        return accessor !== undefined && accessor !== null
    } catch (e) {
        // And we're able to catch the Error it would normally throw for
        // referencing a property of undefined
        return false
    }


}


router.beforeEach((to, from, next) => {
    /* eslint-disable */
    const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
    let isAuthenticated = store.state.isAuthenticated;
    const  tokenid=JwtService.getTokenID();
    const  tokenauth=JwtService.getToken();
    // let $userrole=JwtService.getTokenRole();
    let $userrole= 'Membre'

    let t=this


    // if (!isAuthenticated && tokenauth){
    //if (!isAuthenticated && isset(tokenauth) && requiresAuth){
    if (!isAuthenticated && isset(tokenauth)){
        //if (!isAuthenticated && tokenid){
        // if (!isAuthenticated){

        // store.dispatch('chektoken',{idtoken:tokenauth,expirein:''})
        // Sur panne réseau, une route protégée attend le retour de la connexion
        // (écran d'attente + réessais) au lieu de renvoyer au login ; le token est conservé.
        verifierSessionAvecReprise(store, isset(tokenauth)?tokenauth:"", requiresAuth)
            .then((res) => {

                console.log('to.name',to.name)

                if(!res.data.refresh){


                    // return   next()
                    if (to.name === 'forgotpasswordtoken'){ // route d'forgotpasswordtoken

                        return  next()
                    }
                    else    if (to.name === 'forgotpassword'){ // route d'forgotpassword

                        return  next()
                    }
                    else if (to.name === 'register'){ // route d'inscription

                        return  next()
                    }
                    else if(to.name === 'login'){ // route de login

                        return  next()

                    }else if(to.name === 'registerref'){ // route de registerref

                        return  next()

                    }else if(to.name === 'panierapp' || to.name === 'serveurapp'){ // route de panierapp
 
                        return  next()
 
                    }else if(to.name === 'menuapp'){ // route de menuapp (menu restaurant public)

                        return  next()

                    }else if(to.name === 'shortlinkapp'){ // page interstitielle du raccourcisseur de QR (publique)

                        return  next()

                    }else if(to.name === 'panierrefus'){ // page de refus Scan&Go (publique)

                        return  next()

                    }else if(to.name === 'scancaisseapp'){ // téléphone-scanner de la caisse (publique)

                        return  next()

                    }else  {
                         next({ name: 'login' })
                       // next({ name: '/' })

                    }


                }
                else{

                    // $userrole=JwtService.getTokenRole();
                    //$userrole=res.data.approle;
                    //JwtService.setAuthorization(tokenauth)

                   // store.dispatch('loadlistedesarticles');


                    if (to.name === 'register'
                        || to.name === 'login'
                        /*|| to.name !== 'dashboardbackend'*/
                    ){ // route d'inscription

                        return  next('/')
                       // return  next('/login')
                    }else

                    // Garde défensive : une route sans meta.roles (les routes
                    // restaurant, par ex.) faisait planter le guard sur un
                    // TypeError, et le .catch renvoyait l'utilisateur sur /login.
                    if (!to.meta.roles || to.meta.roles.includes($userrole)) {

                        return   next()
                    }
                    else {

                        return    next('/')

                    }

                }






            })
            .catch((error) => {
                // Route publique sans réponse du serveur : on laisse passer, la
                // page n'a pas besoin de la session.
                if (estErreurReseau(error) && !requiresAuth) return next()
                next({ name: 'login' })
                //next()


            });

        /*if (requiresAuth){

            next({ name: 'login' })

        }else{

            next()
        }*/






    }



    else  if (!isAuthenticated){  //il ne faut pas une authentification

       // console.log("isAuthenticated   888 ",isAuthenticated)
        //console.log("requiresAuth   888 ",requiresAuth)



        if (requiresAuth){
            next({ name: 'login' })
        }else{


            next()


        }




        /* if (to.name === 'forgotpasswordtoken'){ // route d'forgotpasswordtoken

             return  next()
         }
         else
         if (to.name === 'forgotpassword'){ // route d'forgotpassword

             return  next()
         }
         else   if (to.name === 'register'){ // route d'inscription

             return  next()
         }
         else if(to.name === 'login'){ // route de login

             return  next()

         }else if(to.name === 'registerref'){ // route de registerref

             return  next()

         }else  {
           //  next({ name: 'login' })
            // next({ name: '/' })
             next()
         }*/



    }
    else  {

        next()

    }






})


/*

if (process.env.NODE_ENV === 'production') {
    app.config.warnHandler = () => {};
}
*/



/*
createApp(App)
    .use(VueAxios,axios)
    .use(router)
    .use(VueHtmlToPaper)
    .use(store)
    .mount('#template');*/


// ── Montage garanti : l'échec de la DB ne doit JAMAIS bloquer l'UI ──
// Idempotent : appelé par la séquence normale, par le retry et par le
// watchdog ; seul le premier appel monte réellement l'application.
function mountApp() {
    if (window.__appMounted) return;
    window.__appMounted = true;

    createApp(App)
        .use(VueAxios,axios)
        .use(permissiondirective)
        .use(router)
        .use(VueHtmlToPaper)
        .use(store)
        .mount('#template');
}

// Un autre onglet applique une nouvelle version du schéma : indexedDBService a
// fermé notre connexion pour le laisser passer. La base est désormais
// inutilisable ici. On ne recharge PAS d'office - cela couperait une saisie de
// caisse en cours - on avertit, et l'utilisateur recharge quand il a terminé.
window.addEventListener('hsig:db-obsolete', (e) => {
    const d = e.detail || {};
    console.warn(`[DB] Connexion fermée pour laisser passer l'upgrade v${d.from} → v${d.to}`);
    try {
        toastr['warning'](
            "Une nouvelle version a été installée dans un autre onglet. " +
            "Terminez l'opération en cours puis rechargez cette page.",
            '<b>Rechargement requis</b>',
            { timeOut: 0, extendedTimeOut: 0, closeButton: true, tapToDismiss: false }
        );
    } catch (err) {
        console.warn('[DB] Notification impossible', err);
    }
});

// Séquence de nettoyage - chaque étape est isolée pour qu'aucune ne puisse
// faire tomber le boot. cleanExpiredOrders(), contrairement aux deux autres,
// n'a pas son propre try/catch : sans ceci, une exception rejetterait toute
// la chaîne et laisserait une page blanche.
async function runBootMaintenance() {
    const steps = [
        cleanAllExpiredData,
        _autoCleanCompleted,
        cleanExpiredOrders,
        purgeComptabilisationVente,   // ventes comptabilisées : rétention 9 jours de caisse
        purgeTrash,                   // corbeille orderQueue : rétention 30 jours
    ];
    for (const step of steps) {
        try {
            await step();
        } catch (e) {
            console.warn(`[boot] Étape de nettoyage ignorée (${step.name})`, e);
        }
    }
}

// Ouvre la base ; en cas d'erreur irrécupérable (VersionError d'un bundle
// périmé servi par le service worker, base corrompue, upgrade avorté), purge
// automatiquement et réessaie UNE fois. C'est l'automatisation du geste manuel
// « supprimer IndexedDB + vider localStorage » qui débloquait les clients.
//
// Le contrôle de version doit précéder initDB() : l'ouverture en DB_VERSION
// déclenche l'upgrade destructif et écraserait la version périmée avant lecture.
async function openDBWithSelfHeal() {
    try {
        const res = await forceDBVersionCheck();
        if (res.purged) {
            console.warn(`[DB] Purge forcée v${res.from} → v${res.to}`);
        }
        await initDB();
    } catch (err) {
        console.error('[boot] Ouverture DB échouée → purge auto puis nouvelle tentative', err);
        await hardResetAll();   // supprime IndexedDB + localStorage + sessionStorage
        await initDB();         // seconde tentative sur une base neuve
    }
}

// ── Contrôle de version applicatif ──
// Compare version.json (RÉSEAU, ce qui est déployé) à la version compilée dans
// ce bundle (ce qui tourne). Divergence → modale bloquante, mise à jour
// obligatoire. Voir appVersionService.js pour le détail du raisonnement.
//
// Démarré APRÈS l'ouverture de la base : forceDBVersionCheck() doit être la
// toute première opération IndexedDB du boot, sans quoi le contrôle de schéma
// devient aveugle. Idempotent, donc appelable depuis le watchdog comme depuis
// la séquence normale.
//
// Actif en production seulement - en développement, version.json et le bundle
// sortent du même package.json et concordent toujours.
//
// Deux échappatoires pour le tester : window.__hsigForceGate (avant le boot) ou
// localStorage 'hsig-force-gate' = '1', qui survit au rechargement et permet
// donc de faire vérifier la modale sur un poste client par le support.
function demarrerControleDeVersion() {
    let force = !!window.__hsigForceGate;
    try {
        force = force || window.localStorage.getItem('hsig-force-gate') === '1';
    } catch (e) { /* localStorage indisponible */ }

    if (process.env.NODE_ENV !== 'production' && !force) return;

    try {
        console.log(`[version] Bundle en cours d'exécution : ${VERSION_BUNDLE}`);
        demarrerSurveillance(afficherGateMiseAJour);
    } catch (err) {
        // Une panne du contrôle de version ne doit jamais empêcher de vendre.
        console.error('[version] Contrôle de version indisponible', err);
    }
}

// Watchdog : si le boot n'a pas monté l'app après 8 s (upgrade bloqué par un
// autre onglet, promesse qui ne résout jamais), on monte quand même l'app.
const bootWatchdog = setTimeout(() => {
    console.error('[boot] Timeout d’initialisation montage forcé de l’application');
    mountApp();
    demarrerControleDeVersion();
}, 8000);

(async () => {
    try {
        await openDBWithSelfHeal();
        console.log('📦 IndexedDB initialisé');
        await runBootMaintenance();
    } catch (err) {
        console.error('❌ Erreur d’initialisation de la DB (app montée malgré tout) :', err);
    } finally {
        clearTimeout(bootWatchdog);
        mountApp();             // l'UI s'affiche dans TOUS les cas
        demarrerControleDeVersion();
    }
})();

